import { render, staticRenderFns } from "./CongregationSwitch.vue?vue&type=template&id=0d965623"
import script from "./CongregationSwitch.vue?vue&type=script&lang=js"
export * from "./CongregationSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports